import { useMemo } from 'react'
import { abi } from '@/abi/Staking2a'
import { wagmiConfig } from '@/config/wagmi-config'
import { makeWriteContractAsync } from '@/utils/wagmi/makeOperations'
import { useStaking2aAddress } from './useStaking2aContract'

export function useWriteStaking2aContract() {
	const staking2aAddress = useStaking2aAddress()

	return useMemo(() => makeWriteContractAsync(wagmiConfig, { abi, address: staking2aAddress }), [staking2aAddress])
}
